import axios from 'axios';

export default axios.create({
    baseURL: 'https://api.werafoods.com/order/v1/',
    headers: { 'content-type': 'application/x-www-form-urlencoded' },
});
